import { render, staticRenderFns } from "./AdsCard.vue?vue&type=template&id=f0185126&scoped=true&"
import script from "./AdsCard.vue?vue&type=script&lang=js&"
export * from "./AdsCard.vue?vue&type=script&lang=js&"
import style0 from "./AdsCard.vue?vue&type=style&index=0&id=f0185126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0185126",
  null
  
)

export default component.exports